import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://6dee1d04e1d3da1f326a9560f1582faf@o4510998722904064.ingest.de.sentry.io/4511047284097104',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
});

export default Sentry;
